import { useState } from 'react'
import { Button } from '@components/ui/Button'

interface TokenRevealCardProps {
  rawToken: string
  onConfirm: () => void
}

export function TokenRevealCard({ rawToken, onConfirm }: TokenRevealCardProps) {
  const [copied, setCopied] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(rawToken)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="space-y-5">
      <div className="p-4 rounded-lg border border-yellow-500/30 bg-yellow-500/5 text-sm text-yellow-300">
        This is your API token. It will only be shown <strong>once</strong>. Copy it now and store
        it somewhere safe. You will need it to log in.
      </div>

      <div className="relative">
        <code className="block w-full p-4 rounded-lg bg-ai-darker border border-ai-border text-ai-accent text-sm font-mono break-all select-all">
          {rawToken}
        </code>
        <button
          onClick={handleCopy}
          className="absolute top-2 right-2 px-3 py-1 text-xs rounded-md bg-ai-accent/20 text-ai-accent hover:bg-ai-accent/30 transition-colors"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>

      <label className="flex items-start gap-3 cursor-pointer group">
        <input
          type="checkbox"
          checked={saved}
          onChange={(e) => setSaved(e.target.checked)}
          className="mt-0.5 accent-ai-accent"
        />
        <span className="text-sm text-gray-300 group-hover:text-gray-200">
          I have saved my token in a secure location. I understand it cannot be recovered.
        </span>
      </label>

      <Button className="w-full" onClick={onConfirm} disabled={!saved}>
        Continue to Dashboard
      </Button>
    </div>
  )
}
